import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//调拨数据监测
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}